import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
//Components
import Form from './Form.constants';
//Redux
import { useSelector, useDispatch } from 'react-redux';
import { updateDrawer } from '../../redux/drawers/thunks';
import useScan from '../../hooks/useScan';

const EditDrawer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();

  useEffect(() => {
    setDestination('act-e-dra', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const location = useLocation();
  const idEdit: number = parseInt(location?.pathname.split('/').pop() || '');
  // drawer a edit
  const { drawers } = useSelector((state: any) => state.drawers.drawers);
  const draweredit = drawers.filter((item: any) => item.id === idEdit);
  const submitEditDrawer = (values: any) => {
    dispatch(updateDrawer({ values }))
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate('/drawers', { replace: true });
        }
      });
  };

  return (
    <Form
      submitDrawer={submitEditDrawer}
      initialValues={draweredit[0]}
      actionText={'GUARDAR'}
    />
  );
};

export default EditDrawer;
